import {
  IDataPreference,
  IFiltrosFluxoDeCaixa
} from "@/features/financas/views/Indicadores/@types/type";
import { EWidgets } from "@/features/financas/views/Indicadores/@types/enums";
import PreferenciasTemplate from "../../Preferencias/strategy/PreferenciasTemplate";

export default class PreferenciasFluxoDeCaixa extends PreferenciasTemplate {
  constructor() {
    super(EWidgets.FluxoCaixaPainel);
  }

  obterStatus(fieldName: string) {
    const status = this.filtrosDoCard.find(
      (preferencia: IDataPreference) => preferencia.fieldName == fieldName
    );

    return status?.fieldData;
  }

  SalvarFiltroFluxoDeCaixa(data: IFiltrosFluxoDeCaixa) {
    const panelFluxoFilter = {
      contas: data.panelFluxoFilter?.contas || [],
      Status: data.panelFluxoFilter?.Status || "0",
      PlanosOrcamentarios: data.panelFluxoFilter.PlanosOrcamentarios || [],
      APartirUltimoDiaConciliado:
        data.panelFluxoFilter?.APartirUltimoDiaConciliado || false,
      ExibirParcelasNaoAprovadas:
        data.panelFluxoFilter?.ExibirParcelasNaoAprovadas || false,
      OcultarTransferencias:
        data.panelFluxoFilter?.OcultarTransferencias || false,
      ValoresNosDiasOriginais:
        data.panelFluxoFilter?.ValoresNosDiasOriginais || false,
      OcultarDinheiroDeCaixasAbertos:
        data.panelFluxoFilter?.OcultarDinheiroDeCaixasAbertos || false,
      AdicionarUmDiaNoVencimentoDeBoletosAReceber:
        data.panelFluxoFilter?.AdicionarUmDiaNoVencimentoDeBoletosAReceber ||
        false,
      OcultarTitulosVencidos:
        data.panelFluxoFilter?.OcultarTitulosVencidos || false
    };

    const hasFilledValue = Object.values(panelFluxoFilter).some((value) => {
      if (Array.isArray(value)) {
        return value.length > 0;
      }

      return value !== false && value !== "0" && value !== "";
    });

    if (hasFilledValue) {
      this.salvarFiltro(panelFluxoFilter);
    }
  }
}
